export default function introAnimated() {
	if ($('.has-intro-animation').length) {
		$('.has-intro-animation').addClass('show-intro-animated');
		setTimeout(function() {
			$('.js-intro-animated').slideUp(1000, () => {
				$('.has-intro-animation').addClass('intro-finished-animating')
			});
		}, 3000);
	}
}
